import {ChangeDetectionStrategy, Component, inject, output} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {OverlayRef} from '@angular/cdk/overlay';
import * as _ from 'lodash';
import {filter, map} from 'rxjs/operators';
import {PANEL_DATA} from '../../../../commons/angular/services/panel.service';
import {AccountsHttpService} from '../../../../account/angular/services/accounts-http.service';
import {AccountModel} from '../../../../account/angular/models/account.model';
import {
  SearchSelectFetchPage,
  TimecardSelectPanelData
} from '../timecard-search-select-list/timecard-search-select-list.component';

/** Picks one of the site's demand accounts. */
@Component({
  standalone: false,
  selector: 'app-timecard-account-select-panel',
  template: `
    <app-timecard-search-select-list [fetchPage]="fetchPage"
                                     [selectedId]="selectedId"
                                     searchLabel="Search Account"
                                     emptyLabel="No Accounts Found"
                                     listLabel="Account"
                                     (selected)="onClose.emit($event)">
    </app-timecard-search-select-list>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TimecardAccountSelectPanelComponent {

  // PanelService closes the panel on this output, so the name is part of its contract.
  readonly onClose = output<AccountModel | null>();

  private readonly accountsHttpService = inject(AccountsHttpService);

  readonly selectedId = inject<TimecardSelectPanelData>(PANEL_DATA)?.selectedId;

  readonly fetchPage: SearchSelectFetchPage<AccountModel> = (params) =>
    this.accountsHttpService.getAll({...params, isDemand: true}).pipe(map((response) => ({
      cursor: response.cursor,
      list: _.map(response.list, (account) => ({id: account.id, label: account.name, value: account}))
    })));

  constructor() {
    // The panel sits on top of a dialog: without this, Escape would close the dialog under it.
    inject(OverlayRef).keydownEvents().pipe(
      filter((event) => event.key === 'Escape'),
      takeUntilDestroyed()
    ).subscribe(() => this.onClose.emit(null));
  }
}
